import Tippy from "@tippyjs/react";
import React from "react";

export const OutputAddButtonTooltip = ({button: button}) => {
  return(
    <Tippy content={<span>Adds a new field in the output of your custom endpoint. That can be a custom field, post field, custom table field and so on.</span>}>
      {button}
    </Tippy>
  );
};
